module.exports = __webpack_public_path__ + "static/img/interturis-2.c649da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/interturis-2.jpg
// module id = 3ixh
// module chunks = 1